<template>
  <el-dialog title="导入旧机价值" :visible.sync="dialogVisible" width="400px" top="32vh" center>
    <div>
      <el-row type="flex" justify="center" class="excelBtn">
        <el-col :span="8" class="font-blod">下载excel模版</el-col>
        <el-col :span="8">
          <el-button type="primary" @click="downloadExcelFun">
            <div class="btnclass">
              <img src="../../../assets/download.png" alt="" />
              <span>excel模版下载</span>
            </div>
          </el-button>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" class="excelBtn">
        <el-col :span="8" class="font-blod">导入excel</el-col>
        <el-col :span="8">
          <file-upload ref="fileupload" @addUpload="importUpdateStockByExcel" :title="'导入'" :limit="1" />
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="tableBtn">
      <div @click="cancelExcel">取 消</div>
      <div @click="submitExcel">确认导入</div>
    </div>
  </el-dialog>
</template>
<script>
import FileUpload from '@/components/Upload/fileUpload'
export default {
  components: {
    FileUpload
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      upLoadData: '',
      key: ''
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.$refs.fileupload.$refs.upload.clearFiles()
    },
    closeDialog() {
      this.dialogVisible = false
    },
    downloadExcelFun() {
      const url = '/autoapp-default-server-recovery/api/file/downLoadTemplate'
      const title = '旧机价值导入模板下载'
      this.global.exportExcel(url, { templateName: 'PriceDisplayImportExcel' }, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    importUpdateStockByExcel(item) {
      this.loading = true
      this.upLoadData = item
    },
    submitExcel() {
      if (!this.global.handleEmptyData(this.upLoadData)) {
        let formData = new FormData()
        formData.append('file', this.upLoadData.file)
        let url = `/autoapp-default-server-recovery/api/priceDisplay/import`

        // 添加全局loading防止重复提交
        const loading = this.$loading({
          lock: true,
          text: '导入中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.loading = true

        this.HttpService.post(url, formData)
          .then(res => {
              loading.close()
              this.loading = false
              if(res.statusCode != 200){
                this.$message.error(res.message)
                return
              }
              if (res.data) {
                // data 有值：导入有错误行，下载失败结果文件
                this.$message.error('文件有误, 请查看错误报告')
                this.getErrorReport(res.data)
              } else {
                // data 为 null：全部导入成功
                this.$message.success('导入成功')
                this.$emit('opera-success')
              }
              this.cancelExcel()
          })
          .catch(err => {
            loading.close()
            this.loading = false
            console.error('导入异常:', err)
            this.$message.error('导入异常，请稍后重试')
            this.cancelExcel()
          })
      } else {
        this.$message.error('请上传文件')
      }
    },
    getErrorReport(downLoadId) {
      const url = `/autoapp-default-server-recovery/api/file/downLoadFailById`
      this.global.exportExcel(url, { downId: downLoadId }, '错误文件').catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    //提示导出报错
    errorTips(errorId) {
      let _this = this
      this.$confirm('导入失败，请点击下载结果并检查失败原因，修改后重新导入', '导入结果', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(() => {
          _this.downloadErrorFun(errorId)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        })
    },
    //下载导入结果
    downloadErrorFun(downLoadId) {
      let url = `/autoapp-default-server-recovery/api/oldMachinePrice/downloadFail/${downLoadId}`
      let title = '导入结果下载'
      this.global.exportExcel(url, {}, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    // 取消提交
    cancelExcel() {
      this.$refs.fileupload.$refs.upload.clearFiles()
      this.upLoadData = {}
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
.excelBtn {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.btnclass {
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/importOld.vue